/**
 * Single source of truth for the sobriety DAY COUNT.
 *
 * The number shown everywhere ("X days sober" — Missões headline, home widget,
 * share screen, side menu, Bill, and the clock cards) MUST come from this one
 * function so the value can never disagree across surfaces.
 *
 * Counting rule (calendar days, device-local timezone):
 *   - Compare the start date and "now" at LOCAL MIDNIGHT, ignoring time-of-day.
 *     This makes the count tick over at midnight (expected UX) instead of at the
 *     arbitrary time-of-day the user set up, and respects the user's timezone.
 *   - Add `base_days` (days carried over from an "existing days" / relapse setup).
 *
 * Do NOT reintroduce an elapsed-24h-block count (Math.floor(ms / 86400000)) for
 * the displayed day number — that is what caused the off-by-one (89 vs 90).
 * We use date-fns `differenceInCalendarDays` (not a raw ms division) so the count
 * stays correct across daylight-saving transitions, where a "day" is 23h or 25h.
 */
import { differenceInCalendarDays } from 'date-fns';

export function calculateSobrietyDays(
  startDate: Date,
  baseDays: number,
  now: Date = new Date(),
): number {
  const diffDays = differenceInCalendarDays(now, startDate);

  return (baseDays || 0) + diffDays;
}
